import {
  GridColDef,
  GridActionsCellItem,
  GridActionsColDef,
} from '@mui/x-data-grid';
import { Paper, IconButton, Grid, Tooltip, SpeedDial } from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Visibility,
} from '@mui/icons-material';
import { GridRowParams } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import useConfirmDeleteDialog from '../../hooks/useConfirmDeleteDialog';
import useCheckPermission from '../../hooks/useCheckPermission';
import DataList from '../../components/DataList';
import publisherTypeService from '../../services/publisherTypeService';

export interface PublisherType {
  id: number;
  name: string;
}

const PublisherTypesPage = () => {
  const navigate = useNavigate();
  const { ConfirmDeleteDialog, setParams } = useConfirmDeleteDialog();
  const [rows, setRows] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();

  const { checkPermission } = useCheckPermission();

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    publisherTypeService
      .list()
      .then((response) => {
        if (!response.hasError) setRows(response.records);
        else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  const getActions = (params: GridRowParams) => {
    var actions: any[] = [];

    let readonly = !checkPermission(['ViewPublisherType']);
    actions.push(
      <GridActionsCellItem
        color="primary"
        icon={
          readonly ? (
            <Tooltip title="Megtekintés">
              <Visibility />
            </Tooltip>
          ) : (
            <Tooltip title="Szerkesztés">
              <EditIcon />
            </Tooltip>
          )
        }
        label={readonly ? 'Megtekintés' : 'Szerkesztés'}
        onClick={() => navigate(`/publisherTypes/edit/${params.row.id}`)}
      />
    );

    if (checkPermission(['DeletePublisherType'])) {
      actions.push(
        <GridActionsCellItem
          color="primary"
          icon={
            <Tooltip title="Törlés">
              <DeleteIcon />
            </Tooltip>
          }
          label="Törlés"
          onClick={() =>
            setParams({
              open: true,
              name: 'Biztosan törölni szeretné ezt az elemet?',
              onConfirm: async () => handleDelete(params.row.id),
            })
          }
        />
      );
    }

    return actions;
  };

  const columns: any[] = [
    { field: 'name', headerName: 'Név', flex: 100 },
    {
      field: 'actions',
      type: 'actions',
      flex: 100,
      align: 'right',
      getActions: getActions,
    } as any,
  ];

  const handleDelete = (id: number) => {
    publisherTypeService.delete(id).then((response) => {
      if (response.hasError) {
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('Sikeres törlés!', {
          variant: 'success',
        });
        setRows(rows.filter((row) => row.id !== id));
      }
    });
  };

  return (
    <Paper>
      <Grid container sx={{
        p: 3
      }}>
        <Grid size={12}>
          <h2>Publikáló kategóriák</h2>
        </Grid>
        {checkPermission(['CreatePublisherType']) && (
          <Grid
            container
            size={12}
            sx={{
              p: 2,
              justifyContent: "end"
            }}>
            <Grid sx={{ display: { xs: 'none', sm: 'fixed' } }}>
              <Tooltip title="Publikáló kategória létrehozása">
                <IconButton
                  component={RouterLink}
                  to={`/publisherTypes/create`}
                  color="primary"
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        )}
        <Grid size={12}>
          <DataList rows={rows} columns={columns} />
        </Grid>
        <ConfirmDeleteDialog />{' '}
        <SpeedDial
          onClick={() => {
            navigate(`/publisherTypes/create`);
          }}
          sx={{
            display: { xs: 'fixed', sm: 'none' },
            position: 'fixed',
            bottom: 16,
            right: 16,
          }}
          icon={<AddIcon />}
          ariaLabel={'Hozzáadás'}
        ></SpeedDial>
      </Grid>
    </Paper>
  );
};

export default PublisherTypesPage;
